export const PARAMETERS = 'parameters';

// HC-0136
export const HC_0136_TREATMENT_KEY = 'hc-0136';
export const HC_0136_GROUP_PARAMETER_KEY = 'group';
export let HC_0136_GROUP_PARAMETER_OPTIONS;
(function (HC_0136_GROUP_PARAMETER_OPTIONS) {
  HC_0136_GROUP_PARAMETER_OPTIONS["control"] = "control";
  HC_0136_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(HC_0136_GROUP_PARAMETER_OPTIONS || (HC_0136_GROUP_PARAMETER_OPTIONS = {}));